import React from 'react';

export default class Product extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: null
        };
    }

    productShow(link) {
        document.location.href = link;
        //alert(link)
    }
}